import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";
import Rollbar from "rollbar";

Vue.config.productionTip = false;

Vue.prototype.$rollbar = new Rollbar({
  accessToken: "0b8b9a72269f446599592f39c04e4671",
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: "staging"
  }
});

Vue.config.errorHandler = (err, vm, info) => {
  vm.$rollbar.error(err);
  throw err;
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
